// default store to use
import type { Store } from "redux";
export let store: Store;
export const setStore = (newStore: Store) => {
    store = newStore;
};
